import React, { ReactNode } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

interface ColumnInfoTooltipProps {
  statuses: { name: string; description: string | ReactNode }[]
}

/**
 * Tooltip component for column header info
 * @param statuses - array of objects containing name and description
 */
const ColumnInfoTooltip: React.FC<ColumnInfoTooltipProps> = ({ statuses }) => {
  const classes = useStyles()

  if (!statuses || !Array.isArray(statuses)) {
    return <div className={classes.tooltipContainer}></div>
  }

  return (
    <div className={classes.tooltipContainer}>
      {statuses.map((status) => (
        <p key={status.name} className={classes.tooltipItem}>
          <strong>{status.name}:</strong> {status.description}
        </p>
      ))}
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  tooltipContainer: {
    padding: theme.spacing(1),
  },
  tooltipItem: {
    '& .simple-link-text': {
      color: theme.palette.primary[500],
    },
  },
}))

export default ColumnInfoTooltip
